import React, { Component } from 'react'
import { MARKET_CATEGORIES } from 'components/settings/Rules/constants/market_categories'
import * as CONSTANTS from 'app/modules/rules/constants'

class MarketTagsFilter extends Component {

  constructor(props) {
    super(props)

    const initialValue = props.activeFilter.value

    this.state = {
      selectedCategories: initialValue
    }
  }

  updateCondition = () => {
    const updatedCondition = {
      operator: CONSTANTS.CATEGORY_FILTER_OPERATORS.IS_ANY, 
      value: this.state.selectedCategories
    }

    this.props.onUpdateCondition(updatedCondition)
  }

  addRemoveCategory = (event) => {
    const { checked, value } = event.target
    let selectedCopy = this.state.selectedCategories.slice()

    if (checked) {
      selectedCopy.push(value)
    } else {
      selectedCopy = _.without(selectedCopy, value)
    }

    this.setState({ selectedCategories: selectedCopy }, this.updateCondition)
  }

  renderTagInputs = () => {
    const { selectedCategories } = this.state
    return (
      <ul className="market-categories-list">
        { 
          MARKET_CATEGORIES.map((option, index)=> {
            return (
              <li key={`${option}-${index}`}>
                <label><input type="checkbox" value={option} checked={selectedCategories.includes(option)} onChange={this.addRemoveCategory}/> {option}</label>
              </li>
            ) 
          })
        }
      </ul>
    )
  }

  render() {
    return (
      <div className="rules-choice-content drift-form">
        <div className="rules-choice-selection rules-choice-selection-multi-column">
         {this.renderTagInputs()}
        </div>
      </div>
    )
  }
}

export default MarketTagsFilter



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/components/FilterEditor/FirmographicFilter/MarketTagsFilter.js